import type { ComponentPropsWithRef } from "react";
import { cn } from "../helpers/class-names";

type InputProps = Omit<ComponentPropsWithRef<"input">, "className"> & {
  content?: "text" | "emoji";
};

export function Input({
  content = "text",
  ...props
}: InputProps) {
  return (
    <input
      className={cn("ui-input", `ui-input--${content}`)}
      {...props}
    />
  );
}
